import { ButtonComponentProps } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { MilestoneStatusExtended } from './../types';
import { Button, ButtonSize } from '@bechtel/gds';
import { MilestoneStyledProps } from './types';
import { MilestoneStatusCode } from '@bechtel/types';

function getActionStyles({ status, isInverted }: MilestoneStyledProps) {
  switch (status) {
    case MilestoneStatusCode.PLANNED:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.blue[300]};
            color: ${({ theme }) => theme.colors.blue[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.blue[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.blue[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.blue[300]};
          `;
    case MilestoneStatusCode.CLAIMED:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.orange[300]};
            color: ${({ theme }) => theme.colors.orange[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.orange[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.orange[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.orange[300]};
          `;
    case MilestoneStatusCode.APPROVED:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.green[300]};
            color: ${({ theme }) => theme.colors.green[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.green[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.green[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.green[300]};
          `;
    case MilestoneStatusCode.REJECTED:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.purple[300]};
            color: ${({ theme }) => theme.colors.purple[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.purple[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.purple[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.purple[300]};
          `;
    // FIXME: use enum for blocked
    case MilestoneStatusExtended.BLOCKED:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.red[300]};
            color: ${({ theme }) => theme.colors.red[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.red[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.red[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.red[300]};
          `;

    default:
      return !isInverted
        ? css`
            background-color: ${({ theme }) => theme.colors.grey[300]};
            color: ${({ theme }) => theme.colors.grey[900]};

            &:hover {
              background-color: ${({ theme }) => theme.colors.grey[200]};
            }

            &:active {
              background-color: ${({ theme }) => theme.colors.grey[400]};
            }
          `
        : css`
            border: 1px solid ${({ theme }) => theme.colors.grey[300]};
          `;
  }
}

export const MilestoneActionButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
})<MilestoneStyledProps>`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  ${getActionStyles};

  ${(props) =>
    props.isInverted &&
    css`
      background-color: ${({ theme }) => theme.colors.white};
      color: ${({ theme }) => theme.colors.black};
      &:hover {
        background-color: ${({ theme }) => theme.colors.grey[100]};
      }

      &:active {
        background-color: ${({ theme }) => theme.colors.grey[200]};
      }
    `}
`;

// TODO: look at abstracting this to account for other statuses if needed
export const SecondaryActionButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
})<ButtonComponentProps>`
  background-color: ${({ theme }) => theme.colors.orange[100]};
  border-color: ${({ theme }) => theme.colors.orange[300]};
  color: ${({ theme }) => theme.colors.orange[900]};
  margin-right: ${({ theme }) => theme.spacings[400]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  &:hover {
    background-color: ${({ theme }) => theme.colors.orange[200]};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.orange[400]};
  }
`;
